import { useState } from 'react';
import Taskbar from '../components/Taskbar';
import AnimatedSection from '../components/AnimatedSection';
import PartnershipForm from '../components/PartnershipForm';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";

const CovenantPartnership = () => {
  const [showForm, setShowForm] = useState(false);

  const images = [
    "/images/partnerships/partnership1.jpg",
    "/images/partnerships/partnership2.jpg",
  ];
  const captions = ["Covenant Partnership Forum", "Covenant Partnership Forum"];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const res = await fetch("http://localhost:5000/api/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Server error:", text);
        alert("Submission failed. Server error.");
        return;
      }

      const result = await res.json();
      if (result.success) {
        alert("Thank you for your partnership!");
        e.target.reset();
        setShowForm(false);
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      alert("There was an error. Please try again.");
      console.error(error);
    }
  };

  return (
    <>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-8 min-[942px]:mt-[51px] bg-bg text-text">
        <AnimatedSection images={images} captions={captions} title="Covenant Partnership" />

        <section className="bg-card shadow-theme p-1 my-6 transition-colors duration-500 animate-fadeIn" aria-label="Covenant Partnership Notes">
          <h1 className="text-4xl text-secondary text-center font-extrabold mb-6 border-b-4 border-border">
            COVENANT PARTNERSHIP FORUM [Psalm 50:5]
          </h1>
          <div className='font-semibold'>
          <p className="mb-4 leading-relaxed text-lg font-bold">
            Great Grace beloved in the Lord, you are welcome to the Covenant Partnership forum with the Priest of God, Prophet Kevin N.
          </p>

          <p className="mb-6 italic leading-relaxed text-lg">
            The Lord Jesus, through a Divine encounter, commanded the Man of God to win 1 million souls for the Kingdom, and he emphasized to him saying:
          </p>

          <blockquote className="mb-6 pl-6 border-l-4 text-add border-border italic text-xl">
            "Take them from darkness into the Light, keep them in the Light and Teach them how to Walk in the Light."
          </blockquote>

          <p className="mb-4 leading-relaxed text-lg">
            The Man of God has wholeheartedly committed himself to that Heavenly vision by planting churches across the nations, holding crusades, organizing outreach programs, and sending missionaries into the field.
          </p>

          <p className="mb-6 leading-relaxed text-lg">
            All these activities cost millions monthly to run effectively. The Lord Jesus instructed the Man of God to set up the Covenant Partnership Forum.
          </p>

          <h2 className="text-3xl text-secondary font-bold mb-3 border-b-2 border-border pb-1">
            Purpose of Covenant Partnership
          </h2>

          <ul className="list-disc list-inside mb-6 text-lg space-y-2 font-bold">
            <li>Sustenance of the Man of God [1 Corinthians 9:14].</li>
            <li>Sponsoring Crusades for souls to be healed, delivered, and saved [Luke 8:1-3].</li>
            <li>Payment of TV and Radio Bills [Psalm 68:11].</li>
            <li>Organizing outreaches to assist the needy namely widows, orphans, prisoners [Matthew 25:34-40].</li>
          </ul>

          <h2 className="text-3xl text-secondary font-bold mb-3 border-b-2 border-border pb-1">
            Benefits of being a Covenant Partner
          </h2>

          <p className="mb-6 leading-relaxed text-lg">
            Partnership is a system through which men gain access into the storehouse of God. When you partner with a Man of God, you partake of the grace upon him.
          </p>

          <blockquote className="mb-6 pl-6 border-l-4 text-add border-border italic text-xl">
            "But if some of the branches were broken off, and you, being a wild olive, were grafted in among them and became partaker with them of the root and of the richness of the olive tree, [Romans 11:17]"
          </blockquote>

          <h2 className="text-3xl font-bold mb-3 border-b-2 text-secondary border-border pb-1">
            How to become a Covenant Partner?
          </h2>

          <p className="mb-6 leading-relaxed text-lg">
            Fill the form below, choose your monthly covenant option, and commit to doing your part.
          </p>
          </div>

          <div className="text-center mb-1">
            <button
              onClick={() => setShowForm(true)}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-2 px-6 rounded-full transition"
            >
              Become a Covenant Partner Today
            </button>
          </div>
          
          {showForm && (
            <div className="absolute bg-card pb-6 bottom-[-1700px] md:bottom-[-1230px] w-full shadow-xl animate-fadeIn">
              <button
                onClick={() => setShowForm(false)}
                className="mt-4 bg-add text-white pb-2 px-4 text-3xl font-bold hover:bg-red-700 rounded"
              >
                ×
              </button>
              <div className=" max-h-full overflow-y-auto">
                <PartnershipForm onSubmit={handleSubmit} />
              </div>
            </div>
          )}
        </section>

        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default CovenantPartnership;
